<script setup lang="ts">
import MenuLinksHeader from '~/widgets/header/ui/MenuLinksHeader.vue';
import AnnounceBar from '~/widgets/header/ui/AnnounceBar.vue';
import { useAnnounceBar } from '~/shared/lib/useCountdown';

const emit = defineEmits<{
  (e: 'toggle'): void;
}>();

const {
  isVisible: isAnnounceVisible,
  days: announceDays,
  hours: announceHours,
} = useAnnounceBar();

defineProps<{
  isOpened: boolean;
  isHeaderTwoRows?: boolean;
}>();
</script>

<template>
  <div :class="$style.menu">
    <div :class="$style.menu__button" @click="emit('toggle')">
      <Icon
        v-if="isOpened"
        :class="$style.menu__button__icon"
        name="my-icon:i-close"
      />
      <Icon v-else :class="$style.menu__button__icon" name="my-icon:i-menu" />
    </div>

    <div
      v-if="isOpened"
      :class="[
        $style.menu__wrapper,
        { [$style.menu__wrapper_twoRows!]: isHeaderTwoRows },
      ]"
    >
      <div :class="$style.menu__columns">
        <div :class="$style.menu__wrapper__links">
          <MenuLinksHeader @close-menu="emit('toggle')" />
        </div>
        <div v-if="false" :class="$style.menu__block">
          <div :class="$style.menu__banner"></div>
        </div>
      </div>

      <AnnounceBar
        v-if="isAnnounceVisible"
        :days="announceDays"
        :hours="announceHours"
        :class="$style.menu__announce"
      />
    </div>
  </div>
</template>

<style module lang="scss">
.menu {
  &__button {
    display: flex;
    width: 64px;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      path {
        fill: var(--color-red-1);
      }
    }
  }

  &__columns {
    display: flex;
    flex-flow: nowrap row;
    width: 100%;
  }

  /* min/max, чтобы перебить height: 100% и мобильные 48px из AnnounceBar */
  &__announce {
    flex-shrink: 0;
    min-height: 50px;
    max-height: 50px;
  }

  &__wrapper {
    position: absolute;
    width: 100%;
    display: flex;
    flex-flow: nowrap column;
    left: 0;
    top: var(--space-8x);
    z-index: -10;

    /* Две строки шапки: 54px + 42px */
    &_twoRows {
      top: 96px;
    }

    &__links {
      background-color: var(--color-white);
      padding: var(--space-4x) var(--space-8x);
      width: 100%;
    }
  }

  &__banner {
    width: 240px;
    height: 400px;
    background-color: var(--color-yellow-2);
    flex-shrink: 0;
  }

  &__sitemap {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: var(--space-4x) var(--space-8x);
    width: 100%;
    background-color: var(--color-white);
    gap: var(--space-5x);
    flex-grow: 1;
  }

  &__column {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--space-4x);
    flex: 1;
  }
}

@media (max-width: 1379px) {
  .menu {
    &__block {
      background-color: var(--color-white);
      display: flex;
      align-items: center;
      width: 273px;
    }
    &__wrapper {
      &__links {
        // width: 751px; Пока нет баннера
        // padding-right: 30px; Когда есть баннер
        padding: var(--space-4x) var(--space-8x) var(--space-4x) var(--space-8x);
      }
    }
  }
}

@media (max-width: 1023px) {
  .menu {
    &__block {
      width: 279px;
      align-items: unset;
    }

    &__banner {
      top: 45px;
      position: relative;
    }

    &__wrapper {
      /* 64px кнопок + 48px плашки отдельной строкой */
      &_twoRows {
        top: 112px;
      }

      &__links {
        //width: 489px; // Пока нет баннера
        padding: var(--space-4x) 25px 52px 36px;
      }
    }
  }
}

@media (max-width: 767px) {
  .menu {
    &__wrapper {
      flex-direction: column;
      &__links {
        width: 100%;
        padding: var(--space-3x) var(--space-2-5x);
      }
    }

    &__block {
      background-color: transparent;
      width: 100%;
    }

    &__banner {
      width: 100%;
      top: 0;
      height: 250px;
    }
  }
}
</style>
